import React from "react";
// ANT DESIGN COMPONENTS
import { Tag } from "antd";
// FLATBUFFER TYPES
import { AdapterAuth } from "../../../flatbuffers/generated/archive/adapter-auth";

const AUTH_COLOR_MAP: Record<AdapterAuth, string> = {
  [AdapterAuth.NONE]: "default",
  [AdapterAuth.APIKEY]: "purple",
  [AdapterAuth.PASSWORD]: "cyan",
  [AdapterAuth.JWT]: "geekblue",
  [AdapterAuth.OAUTH]: "volcano",
};

const AUTH_LABEL_MAP: Record<AdapterAuth, string> = {
  [AdapterAuth.NONE]: "NONE",
  [AdapterAuth.APIKEY]: "APIKEY",
  [AdapterAuth.PASSWORD]: "PASSWORD",
  [AdapterAuth.JWT]: "JWT",
  [AdapterAuth.OAUTH]: "OAUTH",
};

function TableColumnAuthType({ authType }: { authType: AdapterAuth }) {
  const label = AUTH_LABEL_MAP[authType] ?? "N/A";
  const color = AUTH_COLOR_MAP[authType] ?? "red";

  return (
    <div>
      <Tag color={color} className="drawer__typeTag">
        {label}
      </Tag>
    </div>
  );
}

export default TableColumnAuthType;
